import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const gameVuex = createNamespacedHelpers("game");
export default {
  name: "mHead",
  computed: {
    ...userVuex.mapState(["isLogin", "balanceInfo", "userInfo", "didInfo"]),
    ...gameVuex.mapState(["gameProgress"])
  },
  data() {
    return {
      popMenuShow: false
    };
  },
  methods: {
    onSkip(path) {
      this.hapticFeedback();
      this.$router.push(path);
    }
  }
};